import React from "react";

import { WHO_WE_ARE } from "npmlinks-constants";

function WhoWeAreRightContent() {
  return (
    (WHO_WE_ARE.rightSideContent &&
      WHO_WE_ARE.rightSideContent.map(obj => (
        <div className="nw-whoweare-rightside-container">
          <label className="nw-whoweare-rightside-content-title">
            {obj.title}
          </label>
          <p> {obj.content} </p>
        </div>
      ))) ||
    null
  );
}

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: WhoWeAreRightContent,
  component: WhoWeAreRightContent,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/WhoWeAre/WhoWeAreRightContent/index.js